import type { ReferenceMultiInputProps } from '@healthnz-prm/fhir-engine-renderer/types'

export default function ReferenceMultiInput(_props: ReferenceMultiInputProps) {
  return null
}
